import { LATITUDE_LIMIT, LONGITUDE_LIMIT, readCoord } from '../../shared/utils/coords';
import { isRecord, toId, toNumber, toText } from '../../shared/utils/parse';
import type { Branch } from '../models/branch/branch.model';

/** null — филиал непригоден: без id он не уйдёт в заказ. Координаты необязательны — их шлют не всем. */
export function mapBranch(raw: unknown): Branch | null {
  if (!isRecord(raw)) {
    return null;
  }
  const id = toId(raw['id']);
  if (id === null) {
    return null;
  }
  const name = toText(raw['name']);
  const address = toText(raw['address']);
  return {
    id,
    // Мусорные и пустые name/address — не повод отбраковать филиал: заказ на нём всё равно оформится.
    name: name ?? address ?? '',
    address: name === null ? '' : (address ?? ''),
    phone: toText(raw['phone']),
    latitude: readCoord(raw['latitude'], LATITUDE_LIMIT),
    longitude: readCoord(raw['longitude'], LONGITUDE_LIMIT),
    distanceKm: toNumber(raw['distanceKm']),
  };
}

export function mapBranches(raw: unknown): Branch[] {
  if (!Array.isArray(raw)) {
    return [];
  }
  const branches: Branch[] = [];
  for (const entry of raw) {
    const branch = mapBranch(entry);
    if (branch !== null) {
      branches.push(branch);
    }
  }
  return branches;
}
